var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, IconButton, Typography, Box, tooltipClasses } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { styled } from '@mui/material/styles';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { useState } from 'react';
const CustomTooltip = styled((_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    return (_jsx(Tooltip, Object.assign({}, props, { sx: { borderRadius: '10px' }, arrow: true, classes: { popper: className } })));
})(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
        color: theme.palette.common.black
    },
    [`& .${tooltipClasses.tooltip}`]: {
        backgroundColor: theme.palette.common.black,
        borderRadius: '10px'
    }
}));
const InfoTooltip = ({ title, description }) => {
    const [open, setOpen] = useState(false);
    const handleTooltipClose = () => {
        setOpen(false);
    };
    const handleTooltipOpen = () => {
        setOpen(true);
    };
    return (_jsx(ClickAwayListener, { onClickAway: handleTooltipClose, children: _jsx(CustomTooltip, { onClose: handleTooltipClose, open: open, sx: { borderRadius: '10px' }, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true, title: _jsxs(Box, { sx: { padding: 1 }, children: [_jsx(Typography, { variant: "h3", fontWeight: 500, gutterBottom: true, children: title }), _jsx("p", { style: { color: 'grey', fontSize: '14px' }, children: description })] }), arrow: true, children: _jsx(IconButton, { onClick: handleTooltipOpen, "aria-label": "Show information", children: _jsx(InfoOutlinedIcon, { color: "secondary", sx: { cursor: 'pointer', fontSize: '16px' } }) }) }) }));
};
export default InfoTooltip;
